import helpers from "../helpers/helpers";
export default {
  modelName: 'license_template',
  versionModelName: 'license_template_version',
  versionTimestampKey: 'created_at',
  label: '證照公版',
  fields: {
    last_version: {
      type: 'last_version',
      fields: {
        training_hours: {
          type: 'number',
          label: '應訓時數',
          maxlength: 10,
        },
        name: {
          type: 'text',
          label: '名稱',
          readonly: true,
        },
        locales: {
          type: 'locales',
          fields: {
            name: {
              type: 'text',
              label: '名稱',
              autofocus: true,
              rules: 'required',
              maxlength: 200,
            },
            precautions: {
              type: 'textarea',
              label: '注意事項',
              maxlength: 1000,
            },
            expired_comment: {
              type: 'textarea',
              label: '效期說明',
              maxlength: 1000,
            },
          },
        },
        statitory_extension_period: {
          type: 'number',
          label: '幾日前展延提醒',
          maxlength: 10,
        },
        recommend_notify_period: {
          type: 'number',
          label: '建議展延前幾日提醒',
          maxlength: 10,
        },
        acts: {
          label: '相關法規',
          type: 'act-picker',
          textkey: 'name',
          noReset: true,
          modelName: 'act',
          requiredField: 'areas',
          conditionKeys: [
            {
              fieldName: 'areas',
              conditionName: 'area',
            },
          ],
        },
        updated_at: {
          type: 'datetime',
          label: '最後更新時間',
          readonly: true,
        },
        updated_admin: {
          type: 'belongsTo',
          label: '最後更新人',
          readonly: true,
          textKey: 'name',
          modeldataName: 'admin',
        },
      },
    },
    training_hours: {
      type: 'number',
      label: '應訓時數',
      maxlength: 10,
    },
    name: {
      type: 'text',
      label: '名稱',
      readonly: true,
    },
    locales: {
      type: 'locales',
      fields: {
        name: {
          type: 'text',
          label: '名稱',
          autofocus: true,
          rules: 'required',
          maxlength: 200,
        },
        precautions: {
          type: 'textarea',
          label: '注意事項',
          maxlength: 1000,
        },
        expired_comment: {
          type: 'textarea',
          label: '效期說明',
          maxlength: 1000,
        },
      },
    },
    statitory_extension_period: {
      type: 'number',
      label: '幾日前展延提醒',
      maxlength: 10,
    },
    recommend_notify_period: {
      type: 'number',
      label: '建議展延前幾日提醒',
      maxlength: 10,
    },
    acts: {
      label: '相關法規',
      type: 'act-picker',
      textkey: 'name',
      noReset: true,
      modelName: 'act',
      conditionKeys: [
        {
          fieldName: 'areas',
          conditionName: 'area',
        },
      ],
    },
    areas: {
      label: '適用地區',
      type: 'multi-layer',
      rules: 'required',
      modelName: 'areas',
      getUrl: 'area',
      requiredField: 'area_sections',
      multiple: true,
      layersSetting: {
        modelName: 'area_sections',
        requiredFieldKey: 'area_sections',
        search: true,
      },
      getText: (data) => {
        let result = ""
        data.forEach((_data) => {
          if (result !== "") {
            result += ","
          }
          result += _data.name
        })
        return result
      },
      fields: {
        modelName: 'area',
        requiredField: 'area_sections',
        layersSetting: {
          modelName: 'area_sections',
          requiredFieldKey: 'area_sections',
          search: true,
        },
      }
    },
    area_sections: {
      label: '適用子地區',
      type: 'hasMany',
    },
    license_type: {
      type: 'belongsTo',
      label: '證照類型',
      rules: 'required',
      textKey: 'name',
      modelName: 'license_type',
      requiredField: 'areas',
      conditionKeys: [
        {
          fieldName: 'areas',
          conditionName: 'area',
          type: 'array'
        },
      ],
    },
    sequence: {
      type: 'text',
      label: '排序',
      maxlength: 10,
    },
    system_classes: {
      type: 'hasMany',
      label: '領域',
      textKey: 'name',
      modelName: 'system_class',
      requiredField: 'areas',
      rules: 'required',
      conditionKeys: [
        {
          fieldName: 'areas',
          conditionName: 'area',
          type: 'array'
        },
      ],
    },
    system_subclasses: {
      conditionKeys: [
        {
          fieldName: 'system_classes',
          conditionName: 'system_class',
          type: 'array',
        },
      ],
      requiredField: 'system_classes',
      label: '子領域',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'system_subclass',
      rules: 'required',
    },
    range_type: {
      type: 'select',
      label: '適用範圍類型',
      items: [
        {
          value: 'general',
          text: '通用',
        },
        {
          value: 'exclusive',
          text: '專屬',
        },
      ],
      defaultValue: 'general',
    },
    factories: {
      type: 'hasMany',
      label: '適用工廠',
      textKey: 'name',
      modelName: 'factory',
      requiredField: 'areas',
      conditionKeys: [
        {
          fieldName: 'areas',
          conditionName: 'area',
          type: 'array',
        },
      ],
      getText: (item) => {
        return helpers.methods.$_CMS_getFactoryName(item)
      },
      displayCheck: (modelData) => {
        if (modelData.range_type === "general") { 
          return true
        } else if(modelData.range_type === "exclusive") {
          return false
        }
      },
    },
    exclusive_factories: {
      type: 'hasMany',
      label: '專屬工廠',
      textKey: 'name',
      modelName: 'factory',
      requiredField: 'areas',
      conditionKeys: [
        {
          fieldName: 'areas',
          conditionName: 'area',
          type: 'array',
        },
      ],
      getText: (item) => {
        return helpers.methods.$_CMS_getFactoryName(item)
      },
      displayCheck: (modelData) => {
        if (modelData.range_type === "general") { 
          return false
        } else if(modelData.range_type === "exclusive") {
          return true
        }
      },
      getRules: (modelData) =>{
        if (modelData.range_type === "exclusive") {
          return "required"
        } else {
          return null
        }
      }
    },
    industry_categories: {
      label: '適用產業類別',
      type: 'multi-layer',
      modelName: 'industry_categories',
      getUrl: 'industry_category',
      multiple: true,
      conditionKeys: [
        {
          fieldName: 'areas',
          conditionName: 'area',
          type: 'array',
        },
      ],
      fields: {
        modelName: 'industry_categories',
        getUrl: 'industry_category',
        conditionKeys: [
          {
            fieldName: 'areas',
            conditionName: 'area',
            type: 'array',
          },
        ],
      }
    },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    status: {
      type: 'select',
      label: '',
      defaultValue: '0',
      items: [
        {
          text: '顯示',
          value: 1,
        },
        {
          text: '隱藏',
          value: 0,
        },
        {
          text: '修訂中',
          value: 2,
        },
      ],
    },
  },
};
